module.exports = __webpack_public_path__ + "img/btn_mail.4a8cf707.png";